export const FooterWrapperStyle = {
  marginTop: "auto",
};

export const FooterItemStyle = {
  flexBasis: ["100%", "27%"],
};

export const FooterContainerStyle = {
  marginTop: "100px",
  py: 5,
  bg: "cardPrimary",
};
